import { Injectable } from '@angular/core';
import { Milestone } from '@app/models/milestone';
import { MilestoneService } from '@app/services/api/milestone.service';
import {
  AddAll,
  LoadFail,
  LoadSuccess,
  Create,
  CreateSuccess,
  CreateFail,
  Load,
  MilestoneActionTypes,
  AddMany,
  AddOne,
  LoadStatuses,
  LoadStatusesSuccess,
  LoadStatusesFail
} from '@core/actions/milestone.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class MilestoneEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType<Load>(MilestoneActionTypes.Load),
    switchMap(action =>
      this.milestonesApi.get(action.FollowId).pipe(
        map((milestones: Milestone[]) => new LoadSuccess(milestones)),
        catchError(error => of(new LoadFail(error)))
      )
    )
  );

  @Effect()
  loadSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<LoadSuccess>(MilestoneActionTypes.LoadSuccess),
    map(action => new AddMany(action.milestones))
  );

  @Effect()
  create$: Observable<Action> = this.actions$.pipe(
    ofType<Create>(MilestoneActionTypes.Create),
    switchMap(action =>
      this.milestonesApi.create(action.data).pipe(
        map((milestone: Milestone) => new CreateSuccess(milestone)),
        catchError(error => of(new CreateFail(error)))
      )
    )
  );

  @Effect()
  createSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<CreateSuccess>(MilestoneActionTypes.CreateSuccess),
    map(action => new AddOne(action.milestone))
  );

  @Effect()
  loadStatuses$: Observable<Action> = this.actions$.pipe(
    ofType<LoadStatuses>(MilestoneActionTypes.LoadStatuses),
    switchMap(action =>
      this.milestonesApi.getStatuses().pipe(
        map((statuses: any) => new LoadStatusesSuccess(statuses)),
        catchError(error => of(new LoadStatusesFail(error)))
      )
    )
  );

  constructor(
    private actions$: Actions,
    private milestonesApi: MilestoneService
  ) {}
}
